import React from 'react'
import { useDispatch } from 'react-redux'
import { setKambiBetslipVisibility } from '@core/Areas/KambiClient/Store'
import { toggleKambiBetSlipVisibility } from '@core/Areas/KambiClient/helpers/visibility'

/** On route enter show kambi bet slip, on exit hide */
export const useToggleKambiBetSlipVisibility = (isEnabled: boolean): void => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    dispatch(setKambiBetslipVisibility(isEnabled))
    toggleKambiBetSlipVisibility(isEnabled)
    return () => {
      dispatch(setKambiBetslipVisibility(false))
      toggleKambiBetSlipVisibility(false)
    }
  }, [isEnabled, dispatch])
}
